
import AdminLayout from "../../commponents/layout/adminLayout";
import { useEffect, useState } from "react";
import type { TableColumn } from "../../commponents/table/types";
import { Pencil, Trash2 } from "lucide-react";

import { createCategory, deleteCategoryById, editCategory, getCategory, getCategoryById } from "../../api/categoryApi";
import Modal from "../../commponents/Modal";
import DataTable from "../../commponents/table/DataTable";
import { showConfirm, showError, showSuccess } from "../../utils/ alert";

interface Category {
  id: number;
  categoryName: string;
}

export default function Category() {

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [category, setCategory] = useState<Category[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [search, setSearch] = useState("");
    
  


  const columns: TableColumn<Category>[] = [
    {
      key: "categoryName",
      title: "Category",
    },
    

    {
      key: "id",
      title: "Action",
      render: (row) => (
        <div className="flex items-center gap-2">
        

          <button
            onClick={() => handleEdit(row.id)}
            className="rounded-lg bg-yellow-100 p-2 text-yellow-600 hover:bg-yellow-200">
            <Pencil size={18} />
          </button>

          <button
            onClick={() => handleDelete(row.id)}
            className="rounded-lg bg-red-100 p-2 text-red-600 hover:bg-red-200">
            <Trash2 size={18} />
          </button>
        </div>
      ),
    },
  ];
  

  const fetchCategory = async () => {
    try {
      setLoading(true);
  
      const response = await getCategory({
        page: currentPage,
        limit: pageSize,
      });
  
      setCategory(response.data.categoryList);
  
      setTotalPages(response.data.pagination.totalPages);
  
      setTotalData(response.data.pagination.totalData);
    } catch (error) {
     showError("Failed", "Failed to Load Category.");
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchCategory();
  }, [currentPage, pageSize]);
    
  useEffect(() => {
  
  }, [category]);
  
 const handleSave = async () => {
   try {
     if (!categoryName.trim()) {
       showError("Category name is required");
       return;
     }

     if (isEdit && selectedId !== null) {
       await editCategory(selectedId, {
         category_name: categoryName,
         status: "Active",
       });

       await showSuccess("Category updated successfully.");
     } else {
       await createCategory({
         category_name: categoryName,
         status: "Active",
       });

       await showSuccess("Category created successfully.");
     }

     await fetchCategory();

     handleCloseModal();
   } catch (error) {

     showError("Failed to save category.");
   }
 };

  const handleEdit = async (id: number) => {
   
    try {
      const { data } = await getCategoryById(id);
      


     setCategoryName(data.data.name);
     setSelectedId(id);
     setIsEdit(true);
     setOpenModal(true);
    } catch (error) {
      showError("Failed", "Failed to update Category.");
    }
   
  };



     const handleDelete = async (id: number) => {
       try {
      const result = await showConfirm(
        "Delete Category",
        "Are you sure you want to delete this Category?"
      );

      if (!result) return;

     await deleteCategoryById(id);

      await showSuccess("Deleted", "Category deleted successfully.");
  
        await fetchCategory();

         // fetchProducts(); // refresh list
       } catch (error) {
    
        showError("Failed", "Failed to save Category.");
       }
     };
  
  const handleCloseModal = () => {
    setOpenModal(false);
    setCategoryName("");
    setSelectedId(null);
    setIsEdit(false);
  };
  
  const handleAdd = () => {
    setIsEdit(false);
    setSelectedId(null);
    setCategoryName("");
    setOpenModal(true);
  };
 
  
    return (
      <AdminLayout>
        <div className="bg-white rounded-3xl p-6">
          <DataTable
            title="Category List"
            columns={columns}
            data={category}
            onAdd={handleAdd}
            onSearch={setSearch}
            showSearch={false}
            showFilter={false}
            pagination={{
              currentPage,
              totalPages,
              pageSize,
              onPageChange: setCurrentPage,
              onPageSizeChange: (size) => {
                setPageSize(size);
                setCurrentPage(1);
              },
            }}
          />

          <Modal
            open={openModal}
            title={isEdit ? "Edit Category" : "Add Category"}
            onClose={handleCloseModal}>
            <div className="space-y-5">
              <div>
                <label className="block mb-2 font-semibold">
                  Category Name
                </label>

                <input
                  type="text"
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  placeholder="type here"
                  className="w-full rounded-lg border border-gray-300 px-4 py-2"
                />
              </div>

              <div className="flex justify-end gap-3">
                <button
                  onClick={handleCloseModal}
                  className="rounded-lg bg-red-600 px-5 py-2 text-white">
                  Cancel
                </button>

                <button
                  onClick={handleSave}
                  className="rounded-lg bg-green-600 px-5 py-2 text-white">
                  {isEdit ? "Update" : "Save"}
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </AdminLayout>
    );
  }


